/* eslint-disable */
// src/services/resultsApi.js
import { client } from "./axiosClient";

export const performResultsApprovalAction = (payload) =>
  // payload deve ser { initiative_value_id, action, comment }
  client.post("/api/results-approval-action/", payload).then((res) => res.data);

export const approveAllResults = (initiativeKpiId) =>
  client
    .post("/api/results-approve-all/", { initiative_kpi_id: initiativeKpiId })
    .then((response) => response.data);
